export default __webpack_public_path__ + "static/media/gt710.11afe996.jpg";